var $537735d934d5a3f9$exports = {};
$537735d934d5a3f9$exports = {
    "valid": `Geldig`
};


export {$537735d934d5a3f9$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
